module.exports = __webpack_public_path__ + "media/src/assets/fonts/Montserrat-Hairline-af3ac151d996baa94cb52c8a3fe01218.otf";